/*
 * A Kbd's chips as a screen reader should have them. The chips are symbols (⌘, ↵, ⇧) that a
 * screen reader reads by name, "place of interest", "return symbol", so a Kbd decorating a control
 * is hidden from it, and the control says its shortcut in `aria-keyshortcuts` instead, in the key
 * names that attribute takes.
 */

/** Each chip a Kbd can show, by the name `aria-keyshortcuts` gives the key. */
const keyNames: Record<string, string> = {
  "⌘": "Meta",
  Ctrl: "Control",
  "⌥": "Alt",
  Alt: "Alt",
  "⇧": "Shift",
  "↵": "Enter",
  Esc: "Escape",
  "↑": "ArrowUp",
  "↓": "ArrowDown",
  "←": "ArrowLeft",
  "→": "ArrowRight",
  Space: "Space",
}

/**
 * The `aria-keyshortcuts` value for a Kbd's strokes, "Control+Enter" for Ctrl ↵, or undefined for
 * a chord: the attribute names keys pressed together, and has no way to say "G then P".
 */
export function keyShortcutsOf(strokes: readonly (readonly string[])[]): string | undefined {
  const [stroke, ...rest] = strokes
  if (!stroke || stroke.length === 0 || rest.length > 0) return undefined
  return stroke.map((chip) => keyNames[chip] ?? chip).join("+")
}
